import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  error: {
    display: "flex",
    rowGap: "16px",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px",
  },
  title: {
    margin: "0",
    fontSize: "28px",
    fontWeight: "700",
  },
  subtitle: {
    fontSize: "16px",
    lineHeight: "24px",
  },
  action: {
    backgroundColor: "#0F172A",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px 16px",
    borderRadius: "8px",
  },
  actionLabel: {
    color: "white",
    paddingLeft: "20px",
  },
}));
